import { NodeAccessOperation } from '@prisma/client';
import { Alert, Button, Flex, Layout, Space, Table, Tag, theme, Typography } from 'antd';
import { ColumnType } from 'antd/es/table';

import { Tables } from '@app/web-components';

import { SnapshotContract, useSnapshot } from '../lib';

export const LandingPage = () => {
  const { token } = theme.useToken();
  const { snapshot, contracts, getXlsxButtonPropsForContract, getDownloadAllButtonProps, getApproveButtonProps } =
    useSnapshot();
  const { parentRef, toolbarRef, getTableHeight } = Tables.useReactiveTableHeight();

  const columns = [
    {
      title: 'Contract Name',
      dataIndex: ['contractName'],
      ellipsis: true,
    },
    {
      title: 'Contract Number',
      width: 150,
      dataIndex: ['contractNumber'],
    },
    {
      title: 'Operations',
      dataIndex: 'operations',
      width: 300,
      render: (operations) => (
        <Space direction="horizontal">
          {operations.map(
            ({ operation, count }) =>
              count > 0 && (
                <Tag color={operation === NodeAccessOperation.ADD ? 'green' : 'red'}>
                  {operation === NodeAccessOperation.ADD ? 'Added' : 'Removed'} {count} CW{count > 1 ? 's' : ''}
                </Tag>
              ),
          )}
        </Space>
      ),
    },
    {
      title: 'Download',
      width: 200,
      render: (record: SnapshotContract) => <Button {...getXlsxButtonPropsForContract(record.id.toString())} />,
    },
  ] as ColumnType<SnapshotContract>[];

  return (
    <Layout.Content
      ref={parentRef}
      style={{
        paddingTop: 24,
        paddingLeft: 24,
        paddingRight: 24,
        margin: 0,
        height: '100%',
        minHeight: 0,
        background: token.colorBgContainer,
        overflow: 'auto',
      }}
    >
      {!!snapshot.approverId && (
        <Alert message="This Snapshot has already been approved." type="info" showIcon style={{ marginBottom: 10 }} />
      )}
      <Flex
        align="baseline"
        ref={toolbarRef}
        style={{
          width: '100%',
          marginBottom: 20,
        }}
      >
        <Typography.Title level={3} style={{ margin: 0, width: '100%' }}>
          Pending Contracts
        </Typography.Title>
        <Flex align="flex-end" gap={10}>
          <Button {...getDownloadAllButtonProps()} />
          <Button {...getApproveButtonProps()} />
        </Flex>
      </Flex>
      <Table
        columns={columns}
        dataSource={Object.values(contracts)}
        scroll={{
          y: getTableHeight(),
        }}
        style={{
          height: getTableHeight(),
        }}
        pagination={false}
      />
    </Layout.Content>
  );
};
